import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Card, Space, Image, Toast } from 'antd-mobile'
import CourseCard from '@/components/CourseCard'
import Carousel from '@/components/Carousel'
import { SpaceStyle } from './order.index'
import useCarouselObjList from '@/hook/useCarouselObjList'
import useCourseList from '@/hook/useCourseList'
import SpinPending from '@/components/SpinPending'
import useRefresh from '@/hook/useRefresh'
import dayjs from 'dayjs'
import type { CarouselObj } from '@/types/info'
// 定义课程页面组件
function CoursesPage(): JSX.Element {
  const navigate = useNavigate()
  const {
    data: carouselObjList,
    isLoading: carouselIsLoading,
    refetch: refreshCarouselObjList,
  } = useCarouselObjList()
  const {
    data: courseList,
    isLoading: courseIsLoading,
    refetch: refreshCourseList,
  } = useCourseList()
  useRefresh([refreshCarouselObjList, refreshCourseList])
  // 仅显示当前处于报名时间窗口内的课程
  const visibleCourseList = (courseList ?? []).filter((course) => {
    const now = dayjs()
    const startTime = dayjs(course.startTime)
    const endTime = dayjs(course.endTime)
    return !now.isBefore(startTime) && !now.isAfter(endTime)
  })

  // 处理课程点击，检查课程状态
  const handleCarouselClick = (carousel:CarouselObj) => {
    const now = dayjs()
    const startTime = dayjs(carousel.startTime)
    const endTime = dayjs(carousel.endTime)

    // 课程未开始报名
    if (now.isBefore(startTime)) {
      Toast.show('未开始报名')
      return
    }

    // 报名已结束
    if (now.isAfter(endTime)) {
      Toast.show('报名已结束')
      return
    }

    // 在报名期间，正常跳转
    navigate({
      to: '/course/detail/$id',
      params: { id: carousel.courseId.toString() },
    })
  }
  return (
    <>
      {/* 固定背景层 */}
      <div
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background:
            'linear-gradient(180deg, #F3BF1C 0%,var(--bg-color)  30%,var(--bg-color) 100%)',
          zIndex: '-1',
        }}
      />

      {/* 可滚动的内容层 */}
      {/* <div style={{ minHeight: '100vh' }}> */}
      <Space
        direction="vertical"
        block
        style={{
          ...SpaceStyle,
          background: 'transparent',
        }}
      >
        <Card
          style={cardCommonStyle}
          title={
            carouselObjList !== undefined && carouselObjList.length === 0 ? (
                <Image src="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"></Image>
            ) : (
              <Carousel
                isLoading={carouselIsLoading}
                carouselObjs={carouselObjList}
                autoPlay={true}
                onClick={(carousel) => handleCarouselClick(carousel)}
              />
            )
          }
          headerStyle={cardHeaderStyle}
        />
        {courseIsLoading ? (
          <SpinPending />
        ) : visibleCourseList.length === 0 ? (
          <Space direction="vertical" block style={SpaceStyle}>
            <Image src="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"></Image>
          </Space>
        ) : (
          visibleCourseList.map((course) => (
            <CourseCard
              key={course.courseId}
              course={course}
              inventory={course.region.reduce(
                (acc, cur) => acc + cur.hasInventory,
                0,
              )}
              onClick={() => navigate({
                to: '/course/detail/$id',
                params: { id: course.courseId.toString() },
              })}
            />
          ))
        )}
      </Space>
      {/* </div> */}
    </>
  )
}
// 定义路由
export const Route = createFileRoute('/courses')({
  component: CoursesPage,
})

// 提取重复的样式为常量，提高可维护性
const cardCommonStyle: React.CSSProperties = {
  textAlign: 'center',
  padding: '0',
  maxWidth: '350px',
  margin: '0 auto',
}

const cardHeaderStyle: React.CSSProperties = {
  borderRadius: '8px',
  overflow: 'hidden',
  padding: '0',
  maxWidth: '350px',
  width: 'auto',
  height: '210px',
  margin: '0 0',
  alignItems: 'stretch',
  flexDirection: 'column',
  justifyContent: 'center',
}
